module.exports = __webpack_public_path__ + "static/media/olx.8298198b.png";